// components/CustomRadio.tsx
import React from "react";

const CustomRadio = ({ value, checked, onChange, label }) => {
  return (
    <div
      onClick={onChange}
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        height: 32,
        fontSize: 16,
        fontWeight: 300,
        color: "#222424",
      }}
    >
      <div
        style={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          border: checked ? "2px solid #0D5E0D" : "2px solid #ccc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 10,
        }}
      >
        {checked && (
          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: "#0D5E0D",
            }}
          />
        )}
      </div>
      {label}
    </div>
  );
};

export default CustomRadio;
